module.exports = __webpack_public_path__ + "static/icon-dark-adef32583addf6ee04997b1fd752a8e4.svg";